import { format as dateFnsFormat, parseISO } from 'date-fns';
import { enUS, ru } from 'date-fns/locale';
import { useCallback } from 'react';
import { useLanguage } from './useLanguage';

// Map of language codes to date-fns locales
const localeMap = {
  ru,
  en: enUS,
  // Add more locales here as needed
  // de: de,
  // fr: fr,
  // es: es,
  // etc.
};

export const useDateLocale = () => {
  const { currentLanguage } = useLanguage();

  // Get locale from map, fallback to English if not found
  const locale = localeMap[currentLanguage as keyof typeof localeMap] || enUS;

  // Wrapper over date-fns format with locale in closure
  const format = useCallback(
    (date: Date | string, formatStr: string) => {
      const dateObj = typeof date === 'string' ? parseISO(date) : date;
      return dateFnsFormat(dateObj, formatStr, { locale });
    },
    [locale]
  );

  return {
    format,
    locale,
    currentLanguage,
  };
};
